export const hero = {
  "title": "Troque entre anfitriões,",
  "titleHighlight": "em toda a Europa",
  "subtitle": "Clube de troca europeu reservado para anfitriões Airbnb com classificação 4,5+ com assinatura única Europa.",
  "cta": "Começar a troca",
  "learnMore": "Saiba mais",
  "stats": {
    "owners": "Proprietários ativos",
    "countries": "Países disponíveis",
    "exchanges": "Trocas realizadas"
  },
  "slogans": {
    "slogan1": {
      "title": "Clube privado",
      "highlight": "anfitriões Airbnb 4,5+",
      "subtitle": "Acesso reservado a anfitriões bem avaliados para trocar num ambiente de confiança."
    },
    "slogan2": {
      "title": "Oferta de lançamento 2026",
      "highlight": "-50% para os primeiros 1000",
      "subtitle": "25EUR/ano em vez de 50EUR/ano, com preço garantido vitalício."
    },
    "slogan3": {
      "title": "Preço vitalício",
      "highlight": "1000 primeiros membros",
      "subtitle": "Os primeiros 1000 inscritos mantêm a tarifa para sempre."
    },
    "slogan4": {
      "title": "Sem intermediários,",
      "highlight": "apenas conexões",
      "subtitle": "Uma comunidade de confiança onde se trocam estadias, não noites vendidas."
    },
    "slogan5": {
      "title": "Junte-se ao clube",
      "highlight": "DONKEY TRAVEL",
      "subtitle": "O clube de troca pensado para anfitriões Airbnb ativos na Europa."
    },
    "slogan6": {
      "title": "Baixa temporada",
      "highlight": "otimizada",
      "subtitle": "Transforme seus períodos vazios em oportunidades de viagem."
    },
    "slogan7": {
      "title": "Faça uma pausa,",
      "highlight": "evite o esgotamento",
      "subtitle": "Respire entre dois períodos de hospedagem trocando sua casa."
    },
    "slogan8": {
      "title": "O espírito de viagem,",
      "highlight": "o verdadeiro",
      "subtitle": "Conheça outros anfitriões e descubra novos lugares a custo reduzido."
    },
    "slogan9": {
      "title": "100% Feito na França",
      "highlight": "(Picardia)",
      "subtitle": "Não é o Vale do Silício, mas o Vale do Alto Somme. Uma plataforma artesanal, humana e orgulhosa de suas raízes."
    }
  }
};
